var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gt-select-tenant',{ref:"selectTenant",staticClass:"rule-form-wrap",on:{"select":_vm.onSelectHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }